import { ButtonHTMLAttributes, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  children: ReactNode;
};

// One Button to rule them all. Variants follow the brand palette: primary
// (blue solid) for main actions, secondary (orange) for highlighted ops
// like "Re-planificar", ghost for low-emphasis text-only buttons, danger
// for destructive confirmations.
export function Button({
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...rest
}: ButtonProps) {
  const sizeCls = size === "sm" ? "px-2.5 py-1 text-xs" : "px-4 py-2 text-sm";
  const base =
    "inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors disabled:opacity-40 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-primary/40";
  const variantCls =
    variant === "primary"
      ? "bg-primary hover:bg-primary-hover text-white"
      : variant === "secondary"
        ? "bg-secondary hover:bg-secondary/90 text-white"
        : variant === "danger"
          ? "bg-state-failed hover:bg-state-failed/90 text-white"
          : "bg-transparent text-ink hover:bg-border/40";
  return (
    <button className={`${base} ${sizeCls} ${variantCls} ${className}`} {...rest}>
      {children}
    </button>
  );
}
